import { singletonAtom } from '@/context/atoms/helper/singletonAtom';
import { type PublicConfig } from '@/helper/AppTypes';
import { useFetch as UseFetch } from '@/helper/useFetch';

export const publicConfigAtom = singletonAtom<Promise<PublicConfig>>(async () => {
  const fetch = UseFetch();
  return await fetch.get<Promise<PublicConfig>>('/api/public-config');
});
